<template>
  <div class="has-btn-bottom">
    <div v-html="detail.html" class="ck-content p-1x"></div>
    <van-popup v-model="showImagePosters" closeable
               position="bottom"
               style="height: 100vh"
    >
      <div @click="showImagePosters = false">
        <img :src="imagePosters" alt="" class="res">
      </div>
    </van-popup>
    <footer class="btn-bottom">
      <van-button type="info" block icon="photo-o" @click="share">分享海报</van-button>
    </footer>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import wx from 'weixin-js-sdk'
export default {
  name: 'NewsInfo',
  // components: { UseTip },
  data() {
    return {
      detail: {},
      imagePosters: '', // 海报图片
      posterId: '', // 二维码携带的分享id
      showImagePosters: false,
      shareId: this.$route.query.shareId || 0, // 是否是扫码分享进来的
      // 区别是 0：业务系统产品推荐 1：会员卡券推荐 3:会员产品推荐 4：图文网页推荐
      // channel: this.$route.query.channel,
      refereeId: this.$route.query.refereeId,
    }
  },
  created() {
    this.shareDetail()
  },
  methods: {
    shareDetail() {
      let obj = {
        share_id: this.shareId,
        article_id: this.$route.query.id,
        // member_id: this.user.member_card_id || 0
        member_id: localStorage.getItem('memberId')
      }
      this.$fetch({
        url: '/api/app_article/GetArticle',
        params: obj
      })
        .then(res => {
          this.detail = res
          if (localStorage.getItem('memberId')) this.getNewShare()
          else {
            this.setWxShare()
            this.poster()
          }
        })
    },
    getNewShare() { // 点击分享按钮时获取分享id
      this.$fetch({
        url: '/api/app_share/NewShare',
        method: 'post',
        data: {
          // share_type: 0：业务系统产品推荐 1：会员卡券推荐 3:会员产品推荐 4：图文网页推荐, 5:活动推荐
          share_type: 4,
          relative_id: this.$route.query.id,
          relative_name: this.detail.name,
          share_member_id: localStorage.getItem('memberId'),
          site_id: localStorage.getItem('siteId')
        }
      })
        .then(res => {
          this.posterId = res.share_id
          this.setWxShare()
          this.poster()
        })
    },
    setWxShare() {
      const that = this
      let url = `${location.origin}${location.pathname}#/news/detail?id=${this.detail.id}&a=${localStorage.getItem('appId')}&t=${localStorage.getItem('server')}`
      if (this.posterId) url += `&shareId=${this.posterId}`
      // console.log(url)
      // 分享到朋友圈
      wx.onMenuShareTimeline({
        title: this.detail.name, // 分享标题
        desc: this.detail.title, // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.detail.image_posters, // 分享图标
        success() {
          that.$toast('分享成功!')
          // 设置成功
        }
      })
      // 分享给朋友
      wx.onMenuShareAppMessage({
        title: this.detail.name, // 分享标题
        desc: this.detail.title, // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.detail.image_posters, // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success() {
          that.$toast('分享成功!')
          // 用户点击了分享后执行的回调函数
        }
      })
      // 分享到qq
      wx.onMenuShareQQ({
        title: this.detail.name, // 分享标题
        desc: this.detail.title, // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.detail.image_posters, // 分享图标
        success() {
          that.$toast('分享成功!')
          // 用户确认分享后执行的回调函数
        },
      })
      // 分享到qq空间
      wx.onMenuShareQZone({
        title: this.detail.name, // 分享标题
        desc: this.detail.title, // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.detail.image_posters, // 分享图标
        success() {
          that.$toast('分享成功!')
          // 用户确认分享后执行的回调函数
        },
      })

    },
    // 点击海报按钮
    share() {
      if (this.detail.image_posters) {
        this.showImagePosters = true
      }
      else {
        this.$toast('系统未配置海报')
      }
    },
    // 画图
    poster() {
      let url = `${location.origin}${location.pathname}#/news/detail?id=${this.detail.id}&a=${localStorage.getItem('appId')}&t=${localStorage.getItem('server')}`
      if (this.posterId) url += `&shareId=${this.posterId}`
      // 二维码
      console.log(url)
      QRCode.toDataURL(url)
        .then(src => {
          const canvas = document.createElement('canvas')
          let width = this.$getViewportSize().width * 2
          let height = this.$getViewportSize().height * 2
          canvas.width = width
          canvas.height = height
          let ctx = canvas.getContext('2d')
          let bgImg = new Image()
          let qrImg = new Image()
          bgImg.setAttribute('crossOrigin', 'Anonymous') // 允许跨域
          bgImg.src = this.detail.image_posters + '?x-oss-process=style/medium'
          bgImg.onload = () => { // 海报背景加载完成
            ctx.drawImage(bgImg, 0, 0, width, height)
            qrImg.src = src
            qrImg.onload = () => { // 二维码加载完成
              ctx.drawImage(qrImg, canvas.width - 208, canvas.height - 208, 200, 200)
              ctx.fillStyle = 'rgba(0,0,0,0.5)'
              ctx.fillRect(width / 2 - 104, height - 76, 210, 60)
              ctx.font = '32px Arial' // 文字大小
              ctx.fillStyle = '#ffffff' // 颜色
              ctx.textAlign = 'center'
              ctx.fillText('长按图片分享', width / 2, height - 32)
              this.imagePosters = canvas.toDataURL('image/png', 0.95)
              this.$toast.clear()
            }
          }
        })
    },
  }
}
</script>

<style scoped>
@import "../assets/css/ckeditor.css";
</style>
